export default [
  {
    path: 'afiliados/afiliados-painel',
    name: 'afiliados-painel',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Painel',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Painel' },
      ]
    }
  },
]